import { z } from '@hono/zod-openapi';

import { InstantSchema, Sha256Schema } from './common';
import {
  ExamSchema,
  MockScoreSchema,
  NoteInboxSchema,
  PortableSettingSchema,
  MilestoneSchema,
  MogakSessionSchema,
  PhotoAssetManifestSchema,
  PlanItemSchema,
  PlanSchema,
  StudyLogSchema,
  SubjectSchema,
  WrongNoteSchema,
} from './entities';
import { EXPORT_SCHEMA_VERSION } from './versions';

export const ExportManifestSchema = z
  .object({
    schemaVersion: z.union([z.literal(1), z.literal(2), z.literal(EXPORT_SCHEMA_VERSION)]),
    exportedAt: InstantSchema,
    appVersion: z.string().min(1).max(100),
    counts: z.record(z.string(), z.number().int().nonnegative()),
    files: z.record(
      z.string(),
      z.object({ sha256: Sha256Schema, byteLength: z.number().int().nonnegative() }).strict(),
    ),
  })
  .strict()
  .openapi('ExportManifest');

export const ExportDataSchema = z
  .object({
    schemaVersion: z.union([z.literal(1), z.literal(2), z.literal(EXPORT_SCHEMA_VERSION)]),
    exams: z.array(ExamSchema),
    subjects: z.array(SubjectSchema),
    studyLogs: z.array(StudyLogSchema),
    wrongNotes: z.array(WrongNoteSchema),
    photoAssets: z.array(PhotoAssetManifestSchema),
    plans: z.array(PlanSchema),
    planItems: z.array(PlanItemSchema),
    milestones: z.array(MilestoneSchema),
    mogakSessions: z.array(MogakSessionSchema),
    mockScores: z.array(MockScoreSchema).optional(),
    noteInbox: z.array(NoteInboxSchema).optional(),
    userSettings: z.array(PortableSettingSchema).optional(),
  })
  .strict()
  .openapi('ExportData');

export type ExportManifest = z.infer<typeof ExportManifestSchema>;
export type ExportData = z.infer<typeof ExportDataSchema>;
